import { apolloClientInstance } from 'gatsby-theme-apollo';
import { gql } from '@apollo/client';

const CreateComment = async ({ authorID, contentID, text }) => {
  const queryResult = await apolloClientInstance
    .mutate({
      mutation: gql`
        mutation {
          createComment(
            input: {
              data: {
                text: "${text}"
                author: "${authorID}"
                tierlist: "${contentID}"
              }
            }
          ) {
            comment {
              id
              text
            }
          }
        }
      `
    })
    .then(result => {
      if (!result.data || !result.data.createComment || !result.data.createComment.comment) {
        return;
      }

      const { comment } = result.data.createComment;
      return comment;
    })
    .catch(error => {
      console.log('something went wrong creating comment', error);
      return false;
    });

  return queryResult;
};

export { CreateComment };
